import { Box } from '@mui/material'
import React, { memo, useRef } from 'react'
import { Season } from '@/types/vod/VodItemDetails'
import 'swiper/css'
import 'swiper/css/navigation'
import { SeasonSlider } from '@/features/VOD/components/SeasonSlider'
import { EpisodeSlider } from '@/features/VOD/components/EpisodesSlider'
import { getSeasonsAndEpisodes } from '@/shared/getContainer/getSeasonsAndEpisodes'
import { isSmartTV } from '@/shared/lib'
import { EpisodeSliderTV } from '@/appTV/Series/components/EpisodeSliderTV'

interface IVodRowContainer {
    seasons: Season[]
    episodePosition: { seasonId: string; episodeId: string }
}

const useSeasonsAndEpisodes = await getSeasonsAndEpisodes()

export const VodRowSeriesContainer = memo(
    ({ seasons, episodePosition }: IVodRowContainer) => {
        const { seasonId, episodeId } = episodePosition

        const containerRef = useRef<HTMLDivElement>(null)

        const { actualSeason, actualEpisodes, handleSelectSeason } =
            useSeasonsAndEpisodes({
                seasons,
                seasonId,
                episodeId,
            })

        return (
            <Box ref={containerRef} width="100%" minHeight="327px" mt="64px">
                <Box>
                    <SeasonSlider
                        seasons={seasons}
                        actualSeason={actualSeason}
                        handleSelectSeason={handleSelectSeason}
                    />
                </Box>

                {isSmartTV() && actualSeason?.id && (
                    <EpisodeSliderTV
                        episodes={actualEpisodes?.episodes}
                        episodeId={episodeId}
                        actualSeasonId={actualSeason.id}
                    />
                )}
                {!isSmartTV() && actualSeason?.id && (
                    <EpisodeSlider
                        episodes={actualEpisodes?.episodes}
                        episodeId={episodeId}
                        actualSeasonId={actualSeason.id}
                    />
                )}
            </Box>
        )
    }
)

VodRowSeriesContainer.displayName = 'VodRowSeriesContainer'
